import { ENUM_ORDER_SORT, METADATA, PARAMETERS } from 'models/common';
import { SURCHARGE_ITEM_DATA } from './payments';

/* =========== ENUM ============ */
export enum JOB_STATUS {
  PENDING = 'pending',
  UPCOMING = 'upcoming',
  STARTED = 'started',
  CANCELLED = 'canceled',
  COMPLETED = 'completed',
  PENDING_COMPLETED = 'pending completion',
}

export enum JOB_SURCHARGE_STATUS {
  PENDING = 'pending',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

/* ===========  INTERFACE ============ */
export interface EDIT_JOB_FORM {
  startDate: moment.Moment;
  endDate: moment.Moment;
  startTime: Date;
  endTime: Date;
}
export interface JOB_LIST_RESPONSE {
  metadata: METADATA;
  records: JOB_ITEM_RESPONSE[];
}

export interface JOB_ITEM_RESPONSE {
  id: string;
  total: number;
  parent_id: string;
  sitter_id: string;
  number: string;
  total_hours: number;
  start_datetime: string;
  end_datetime: string;
  end_datetime_origin: string;
  children: JOB_CHILDREN_ITEM[];
  address: JOB_ADDRESS;
  special_notes: SPECIAL_NOTE;
  duration: number;
  status: JOB_STATUS;
  deleted: boolean;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  is_ac_job: boolean;
  is_trial_job: boolean;
  is_paid: boolean;
  is_extend_ac_job: boolean;
  Parent: JOB_PARENT_INFORMATION;
  Sitter: JOB_SITTER_INFORMATION;
  salary_per_hour: number;
  JobExtensions: JOB_EXTENSION_ITEM[];
  job_surcharges: SURCHARGE_ITEM_DATA[];
  total_hours_origin: number;
}

export interface JOB_EXTENSION_ITEM {
  end_datetime: string;
  id: string;
  start_datetime: string;
  status: string;
  total: string;
}

export interface JOB_CHILDREN_ITEM {
  id: string;
  picture: string;
  age_range: number;
  full_name: string;
  date_of_birth: string;
}

interface JOB_ADDRESS {
  id: string;
  name: string;
  region: string;
  street: string;
  postal_code: string;
  unit_number: string;
  block_number: string;
  Region: {
    name: string;
  };
}

interface SPECIAL_NOTE {
  '0': string;
  '1': string;
  '2': string;
}

export interface JOB_PARENT_INFORMATION {
  profile_picture: string | null;
  User: BOOKING_USER_INFORMATION;
}

interface BOOKING_USER_INFORMATION {
  first_name: string;
  last_name: string;
  date_of_birth: string;
  email: string;
  phone_number: string;
  id?: string;
}

export interface JOB_SITTER_INFORMATION {
  salary_per_hour: number;
  rating: number;
  profile_picture: string;
  star_sitter_badge: number;
  User: BOOKING_USER_INFORMATION;
}

export interface JOB_DETAIL_RESPONSE extends JOB_ITEM_RESPONSE {
  end_datetime_origin: string;
  total_hours_origin: number;
}

export interface GET_LIST_JOB_PARAMS extends PARAMETERS {
  parent_id: string;
  sort_column?: string;
  sort_direction?: ENUM_ORDER_SORT;
}

export interface UPDATE_JOB_PAYLOAD {
  id?: string;
  status?: string;
  end_datetime: string;
}

export interface PREVIEW_EXTEND_JOB_RESPONSE {
  id: string;
  total: number;
  current_job: PREVIEW_JOB;
  extended_job: PREVIEW_JOB;
}

export interface PREVIEW_JOB {
  start_datetime: string;
  end_datetime: string;
  total_hours_origin?: number;
  total_hours?: number;
}
